





















































































































































import { Component, Vue } from 'vue-property-decorator';
import SaveButton from '@/components/App/SaveButton.vue';
import axios from 'axios';
import env from '@/env';
import { User } from '@/types';

@Component({
  components: { SaveButton }
})
export default class UsersView extends Vue {
  allUsers: User[] = [];

  env = env;

  newUser = {
    name: '',
    email: '',
    password: '',
    repeat_password: '',
    permissions: {
      admin: false,
      cutovertool: {
        access: true,
        admin: false
      },
      kanban: {
        access: true,
        editor: true,
        admin: false
      }
    }
  };

  nameAlreadyInUse = '';

  passwordsMatching() {
    return (
      this.newUser.password === this.newUser.repeat_password || 'Passwörter stimmen nicht überein'
    );
  }

  get dataValid() {
    return (
      this.newUser.name.length &&
      this.newUser.email.length &&
      this.newUser.password.length &&
      this.passwordsMatching() === true
    );
  }

  get user() {
    return this.$store.state.user;
  }

  async created() {
    const { data: users } = await axios.get(`${env.backend_url}/user/all`);
    this.allUsers = users;
  }

  async create() {
    return axios
      .post(`${env.backend_url}/user/create`, this.newUser)
      .then((response) => {
        this.allUsers.push(response.data);
        this.newUser = {
          name: '',
          email: '',
          password: '',
          repeat_password: '',
          permissions: {
            admin: false,
            cutovertool: {
              access: true,
              admin: false
            },
            kanban: {
              access: true,
              editor: true,
              admin: false
            }
          }
        };
        return response;
      })
      .catch((err) => {
        this.nameAlreadyInUse = 'Name already in use!';
        throw err;
      });
  }
}
